
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Cryptocurrency = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F1F0FB] to-white">
      <Header />
      <div className="container mx-auto px-4 py-12">
        <div className="mb-8">
          <Link to="/knowledge-hub/basics">
            <Button variant="ghost" className="flex items-center gap-2 hover:bg-[#9b87f5]/10 hover:text-[#9b87f5]">
              <ArrowLeft className="h-4 w-4" />
              Back to Crypto Basics
            </Button>
          </Link>
        </div>

        <article className="prose prose-slate lg:prose-lg max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-[#4A607B] text-center !mt-0">
            Understanding Cryptocurrency
          </h1>

          <p className="text-lg text-gray-700 mb-8 text-center max-w-3xl mx-auto">
            Cryptocurrency is a digital or virtual currency secured by cryptography, making it nearly impossible to counterfeit or double-spend.
          </p>

          <div className="space-y-12">
            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">What is Cryptocurrency?</h2>
              <p className="text-gray-700">
                Many cryptocurrencies are decentralized networks based on blockchain technology. Unlike traditional currencies, cryptocurrency exists solely in digital form and uses complex mathematical algorithms to secure transactions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">Key Characteristics</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Decentralized: Control is distributed across the network</li>
                <li>Transparent: All transactions are publicly auditable</li>
                <li>Immutable: Transactions cannot be altered once recorded</li>
                <li>Global: Facilitates cross-border transactions without intermediaries</li>
                <li>Permissionless: Open participation without authorization</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">How Cryptocurrency Works</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Transactions: Users initiate transfers broadcast to the network</li>
                <li>Verification: Network participants verify transactions</li>
                <li>Block Creation: Verified transactions are grouped into blocks</li>
                <li>Chain Addition: New blocks are added to the blockchain</li>
                <li>Consensus Mechanisms: Various methods ensure transaction validity</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#4A607B] mb-4">Types of Cryptocurrency</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Bitcoin (BTC): The first and most well-known cryptocurrency</li>
                <li>Ethereum (ETH): A platform for building decentralized applications</li>
                <li>Litecoin (LTC): Designed for faster and cheaper transactions</li>
                <li>Stablecoins: Cryptocurrencies pegged to stable assets</li>
              </ul>
            </section>
          </div>
        </article>
      </div>
      <Footer />
    </div>
  );
};

export default Cryptocurrency;
